const key = "add-depredation-fields";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/17*$/);
};

const depredationSection = {
	Id: -1,
	Code: "64af3118-78df-49da-9638-733e991a4aaf",
	Name: "Depredation",
	Order: 4.5
};

const primaryBottomType = {
	Data: [],
	Id: -1, 
	Name: "Primary Bottom Type",
	Order: 25,
	Section: { Code: "a843d66f-b278-46be-9c9d-8b0fd4a30946", Id: 144 },
	Template: "Selection",
	Description: "description",
	Type: { Code: "PRIMARY_BOTTOM" }
};

const primaryBoatMovement = {
	Data: [],
	Id: -2, 
	Name: "Primary Boat Movement",
	Order: 26,
	Section: { Code: "a843d66f-b278-46be-9c9d-8b0fd4a30946", Id: 144 },
	Template: "Selection",
	Description: "description",
	Type: { Code: "PRIMARY_MOVEMENT" }
};

const numberOfSites = {
	Data: [{ Code: "#", Id: 1858, Name: "Whole Number" }],
	Id: -3, 
	Name: "# of Fishing Sites",
	IsSmall: true,
	Order: 19,
	Section: { Code: "c5d2cfaa-e4a5-4417-a0d6-580da249dc4f", Id: 145 },
	Template: "Number",
	Description: "description",
	Type: { Code: "NUMBER" }
};

const isDepredated = {
	Id: -4, 
	Name: "Was Any Catch Depredated?",
	Order: 1,
	Section: { Code: "64af3118-78df-49da-9638-733e991a4aaf", Id: -1 },
	Template: "Boolean",
	Description: "description",
	Type: { Code: "BOOLEAN" }
};

const predatorType = {
	Data: [],
	Id: -5, 
	Name: "Predator Type",
	Order: 2,
	Section: { Code: "64af3118-78df-49da-9638-733e991a4aaf", Id: -1 },
	Template: "Selection",
	Description: "description",
	Type: { Code: "PREDATOR_TYPE" }
};

const whichSites = {
	Data: [],
	Id: -6, 
	Name: "Which Sites?",
	Order: 3,
	Section: { Code: "64af3118-78df-49da-9638-733e991a4aaf", Id: -1 },
	Template: "Selection",
	Description: "description",
	Type: { Code: "PREDATOR_SITES" }
};

const depredatedQty = {
	Data: [],
	Id: -6, 
	IsDetail: true,
	IsDetailColumnHeader: true,
	Name: "# Depredated",
	Order: 50,
	Section: { Code: "235e7487-8629-43de-9c37-15c7ba173a62", Id: 467 },
	Key: { Code: "paul's code" },
	Template: "Number",
	Description: "description",
	Type: { Code: "NUMBER" }
};

const modify = (resp) => {
	const fields = resp.data.Data.Fields;
	const sections = resp.data.Data.Sections;
	
	sections.push(depredationSection);
	fields.push(primaryBottomType, primaryBoatMovement, numberOfSites, isDepredated, predatorType, whichSites, depredatedQty);

	// console.log("added fields", resp.data.Data);
	return resp;
};

export const addDepredationFields = [key, applicable, modify];